// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._comparisonSpecifications__specGroupLabel_1yd4u_1 {
  /* Typography */
  --pa-comparison-specifications-group-label-color-inner: var(
    --pa-comparison-specifications-group-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  /* End Typography */
  --perxis-auto-typography-color-dark-light: var(--pa-comparison-specifications-group-label-color-inner);
}
._comparisonSpecifications__specGroupValue_1yd4u_10 {
  /* Typography */
  --pa-comparison-specifications-group-value-color-inner: var(
    --pa-comparison-specifications-group-value-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-typography-color-darkest: var(--pa-comparison-specifications-group-value-color-inner);
}
._comparisonSpecifications__header_1yd4u_19 {
  text-align: center;
}
._comparisonSpecifications__title_1yd4u_22 {
  --pa-comparison-specifications-title-font-size-xxs-xs-inner: var(
    --pa-comparison-specifications-title-font-size-xxs-xs,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --pa-comparison-specifications-title-font-size-sm-xxl-inner: var(
    --pa-comparison-specifications-title-font-size-sm-xxl,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --perxis-auto-typography-h3-font-size-xxs: var(--pa-comparison-specifications-title-font-size-xxs-xs-inner);
  --perxis-auto-typography-h3-font-size-xs: var(--pa-comparison-specifications-title-font-size-xxs-xs-inner);
  --perxis-auto-typography-h3-font-size-sm: var(--pa-comparison-specifications-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-md: var(--pa-comparison-specifications-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-lg: var(--pa-comparison-specifications-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-xl: var(--pa-comparison-specifications-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-xxl: var(--pa-comparison-specifications-title-font-size-sm-xxl-inner);
}
._comparisonSpecifications__row_1yd4u_39 {
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  grid-auto-rows: 0;
  overflow: hidden;
}
@media (min-width: 1200px) {
  ._comparisonSpecifications__row_1yd4u_39 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 36px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._comparisonSpecifications__row_1yd4u_39 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 32px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  ._comparisonSpecifications__row_1yd4u_39 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 28px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  ._comparisonSpecifications__row_1yd4u_39 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
  }
}
@media (min-width: 0px) and (max-width: 575px) {
  ._comparisonSpecifications__row_1yd4u_39 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 16px;
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
